import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { ICatalogueState }  from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const catalogueModule: Module<ICatalogueState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default catalogueModule
